var _g, _g2, _path, _path2, _path3, _path4, _g3, _g4, _path5, _path6, _g5, _g6, _path7, _path8, _g7, _g8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 50,
    viewBox: "0 0 290 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_31580_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.513 37.6331C160.013 37.0196 159.562 36.1398 158.77 36.1268C148.664 35.9604 140.212 36.1472 129.758 36.7832C128.967 36.8314 128.555 37.7311 129.083 38.3217C132.746 42.4201 138.074 45 144.004 45C150.26 45 155.845 42.1291 159.513 37.6331Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 15.0579C126.252 15.7378 126.827 16.5294 127.606 16.436C139.173 15.048 147.698 14.6341 159.788 15.3703C160.575 15.4182 161.104 14.5873 160.668 13.9313C157.083 8.54757 150.958 5 144.004 5C136.576 5 130.093 9.04797 126.643 15.0579Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_31580_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.513 37.6331C160.013 37.0196 159.562 36.1398 158.77 36.1268C148.664 35.9604 140.212 36.1472 129.758 36.7832C128.967 36.8314 128.555 37.7311 129.083 38.3217C132.746 42.4201 138.074 45 144.004 45C150.26 45 155.845 42.1291 159.513 37.6331Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.643 15.0579C126.252 15.7378 126.827 16.5294 127.606 16.436C139.173 15.048 147.698 14.6341 159.788 15.3703C160.575 15.4182 161.104 14.5873 160.668 13.9313C157.083 8.54757 150.958 5 144.004 5C136.576 5 130.093 9.04797 126.643 15.0579Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.513 37.6331C160.013 37.0196 159.562 36.1398 158.77 36.1268C148.664 35.9604 140.212 36.1472 129.758 36.7832C128.967 36.8314 128.555 37.7311 129.083 38.3217C132.746 42.4201 138.074 45 144.004 45C150.26 45 155.845 42.1291 159.513 37.6331Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.643 15.0579C126.252 15.7378 126.827 16.5294 127.606 16.436C139.173 15.048 147.698 14.6341 159.788 15.3703C160.575 15.4182 161.104 14.5873 160.668 13.9313C157.083 8.54757 150.958 5 144.004 5C136.576 5 130.093 9.04797 126.643 15.0579Z",
    stroke: "#4C4CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.513 37.6331C160.013 37.0196 159.562 36.1398 158.77 36.1268C148.664 35.9604 140.212 36.1472 129.758 36.7832C128.967 36.8314 128.555 37.7311 129.083 38.3217C132.746 42.4201 138.074 45 144.004 45C150.26 45 155.845 42.1291 159.513 37.6331Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.643 15.0579C126.252 15.7378 126.827 16.5294 127.606 16.436C139.173 15.048 147.698 14.6341 159.788 15.3703C160.575 15.4182 161.104 14.5873 160.668 13.9313C157.083 8.54757 150.958 5 144.004 5C136.576 5 130.093 9.04797 126.643 15.0579Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_31580_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.859 27.4656C163.988 26.4133 163.172 25.5115 162.115 25.4264C149.235 24.3883 139.184 24.2251 125.89 24.9245C124.831 24.9802 123.99 25.8596 124.089 26.9156C124.23 28.4145 124.537 29.8654 124.991 31.2496C125.253 32.0473 126.032 32.5408 126.871 32.5118C139.383 32.0783 149.06 32.0468 161.196 32.3747C162.035 32.3973 162.811 31.8976 163.066 31.0975C163.439 29.9298 163.707 28.7155 163.859 27.4656Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_31580_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.859 27.4656C163.988 26.4133 163.172 25.5115 162.115 25.4264C149.235 24.3883 139.184 24.2251 125.89 24.9245C124.831 24.9802 123.99 25.8596 124.089 26.9156C124.23 28.4145 124.537 29.8654 124.991 31.2496C125.253 32.0473 126.032 32.5408 126.871 32.5118C139.383 32.0783 149.06 32.0468 161.196 32.3747C162.035 32.3973 162.811 31.8976 163.066 31.0975C163.439 29.9298 163.707 28.7155 163.859 27.4656Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.859 27.4656C163.988 26.4133 163.172 25.5115 162.115 25.4264C149.235 24.3883 139.184 24.2251 125.89 24.9245C124.831 24.9802 123.99 25.8596 124.089 26.9156C124.23 28.4145 124.537 29.8654 124.991 31.2496C125.253 32.0473 126.032 32.5408 126.871 32.5118C139.383 32.0783 149.06 32.0468 161.196 32.3747C162.035 32.3973 162.811 31.8976 163.066 31.0975C163.439 29.9298 163.707 28.7155 163.859 27.4656Z",
    stroke: "#E33CD5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.859 27.4656C163.988 26.4133 163.172 25.5115 162.115 25.4264C149.235 24.3883 139.184 24.2251 125.89 24.9245C124.831 24.9802 123.99 25.8596 124.089 26.9156C124.23 28.4145 124.537 29.8654 124.991 31.2496C125.253 32.0473 126.032 32.5408 126.871 32.5118C139.383 32.0783 149.06 32.0468 161.196 32.3747C162.035 32.3973 162.811 31.8976 163.066 31.0975C163.439 29.9298 163.707 28.7155 163.859 27.4656Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_31580_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 20.5C126.667 18.5 129.333 18.5 132 20.5C134.667 22.5 137.333 22.5 140 20.5C142.667 18.5 145.333 18.5 148 20.5C150.667 22.5 153.333 22.5 156 20.5C158.667 18.5 161.333 18.5 164 20.5",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_31580_478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 20.5C126.667 18.5 129.333 18.5 132 20.5C134.667 22.5 137.333 22.5 140 20.5C142.667 18.5 145.333 18.5 148 20.5C150.667 22.5 153.333 22.5 156 20.5C158.667 18.5 161.333 18.5 164 20.5",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124 20.5C126.667 18.5 129.333 18.5 132 20.5C134.667 22.5 137.333 22.5 140 20.5C142.667 18.5 145.333 18.5 148 20.5C150.667 22.5 153.333 22.5 156 20.5C158.667 18.5 161.333 18.5 164 20.5",
    stroke: "#00CCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124 20.5C126.667 18.5 129.333 18.5 132 20.5C134.667 22.5 137.333 22.5 140 20.5C142.667 18.5 145.333 18.5 148 20.5C150.667 22.5 153.333 22.5 156 20.5C158.667 18.5 161.333 18.5 164 20.5",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_31580_478)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 137.234 39.9812)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.708,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 152.708 11.3542)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 150.16 39.9833)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 142.5 12)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.708,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 146.708 8.35415)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 144 41.75)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.793,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 135.793 10.5826)",
    stroke: "#4C4CFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_31580_478)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 137.234 39.9812)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.708,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 152.708 11.3542)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 150.16 39.9833)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 142.5 12)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.708,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 146.708 8.35415)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 144 41.75)",
    stroke: "#4C4CFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.793,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 135.793 10.5826)",
    stroke: "#4C4CFF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 137.234 39.9812)",
    stroke: "#4C4CFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.708,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 152.708 11.3542)",
    stroke: "#4C4CFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 150.16 39.9833)",
    stroke: "#4C4CFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 142.5 12)",
    stroke: "#4C4CFF"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.708,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 146.708 8.35415)",
    stroke: "#4C4CFF"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 144 41.75)",
    stroke: "#4C4CFF"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.793,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 135.793 10.5826)",
    stroke: "#4C4CFF"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.885492 0.464655 0.464655 -0.885492 137.234 39.9812)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.708,
    cy: 11.3542,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 152.708 11.3542)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 150.16 39.9833)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.5,
    cy: 12,
    rx: 1.5,
    ry: 1,
    transform: "rotate(180 142.5 12)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.708,
    cy: 8.35415,
    rx: 1.5,
    ry: 1,
    transform: "rotate(15 146.708 8.35415)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1,
    ry: 0.75,
    transform: "matrix(1 0 0 -1 144 41.75)",
    stroke: "white",
    strokeWidth: 0.5
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.793,
    cy: 10.5826,
    rx: 1.5,
    ry: 1,
    transform: "rotate(-27.6879 135.793 10.5826)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 25.544C1.968 25.544 1.29067 25.304 0.768 24.824C0.256 24.3333 0 23.672 0 22.84C0 21.7413 0.432 20.9467 1.296 20.456C1.712 20.2213 2.21333 20.104 2.8 20.104H14.128V22.2H3.328C2.74133 22.2 2.448 22.424 2.448 22.872C2.448 23.32 2.74133 23.544 3.328 23.544L11.808 23.56C12.64 23.56 13.312 23.8053 13.824 24.296C14.3467 24.7867 14.608 25.448 14.608 26.28C14.608 27.4 14.176 28.1947 13.312 28.664C12.9067 28.888 12.4053 29 11.808 29H0V26.904L11.28 26.92C11.8667 26.92 12.16 26.6907 12.16 26.232C12.16 25.784 11.8667 25.56 11.28 25.56L2.8 25.544Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.425 29H21.361C20.4223 29 19.745 28.7867 19.329 28.36C19.0623 28.0827 18.8863 27.768 18.801 27.416C18.737 27.1813 18.705 26.8187 18.705 26.328V22.2H17.105V20.104H18.705V16.552H21.377V20.104H29.425V22.2H21.377V25.672C21.377 26.1627 21.489 26.4987 21.713 26.68C21.8943 26.8293 22.1983 26.904 22.625 26.904H29.425V29Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8809 26.904H46.1769V29H36.5289C35.1422 29 34.0809 28.6107 33.3449 27.832C32.6195 27.0427 32.2569 25.9493 32.2569 24.552C32.2569 23.1547 32.6195 22.0667 33.3449 21.288C34.0809 20.4987 35.1422 20.104 36.5289 20.104H46.1769V22.2H36.8809C36.3902 22.2 35.9849 22.3387 35.6649 22.616C35.5155 22.744 35.3235 23.0427 35.0889 23.512L35.0729 23.544H46.1769V25.544H35.0729L35.0889 25.592C35.3022 26.0507 35.4942 26.3493 35.6649 26.488C35.9849 26.7653 36.3902 26.904 36.8809 26.904Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4002 29C51.3522 29 50.0349 28.168 49.4482 26.504C49.2243 25.864 49.1122 25.192 49.1122 24.488V20.072H52.0243V24.216C52.0243 24.9093 52.2376 25.4533 52.6642 25.848C53.0056 26.168 53.4963 26.328 54.1362 26.328H62.5042V29H53.4002Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8177 29C67.7698 29 66.4524 28.168 65.8657 26.504C65.6417 25.864 65.5297 25.192 65.5297 24.488V20.072H68.4417V24.216C68.4417 24.9093 68.6551 25.4533 69.0817 25.848C69.4231 26.168 69.9137 26.328 70.5537 26.328H78.9218V29H69.8177Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5553 22.2V20.104H93.2272C94.2832 20.104 95.1206 20.3813 95.7393 20.936C96.1233 21.2773 96.3846 21.6773 96.5233 22.136C96.6193 22.4773 96.6673 22.9573 96.6673 23.576V29H84.7473C83.8726 29 83.1846 28.76 82.6833 28.28C82.1819 27.8 81.9313 27.128 81.9313 26.264C81.9313 25.4 82.1819 24.7333 82.6833 24.264C83.1953 23.784 83.8833 23.544 84.7473 23.544H93.9953V23.464C93.9953 22.8027 93.7499 22.4027 93.2593 22.264C93.1099 22.2213 92.8806 22.2 92.5713 22.2H82.5553ZM93.9953 26.904V25.544H85.4512C84.8859 25.544 84.6032 25.7733 84.6032 26.232C84.6032 26.68 84.8859 26.904 85.4512 26.904H93.9953Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.182 23.24C110.182 22.9413 110.087 22.7067 109.895 22.536C109.756 22.408 109.543 22.344 109.255 22.344L102.614 22.328V29H99.9425V20.104L109.702 20.072C110.748 20.072 111.548 20.3653 112.103 20.952C112.604 21.4853 112.854 22.0987 112.854 22.792V23.72H110.182V23.24Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M185.232 30H174V17.552H176.672V21.104H185.232C187.045 21.104 188.299 21.776 188.992 23.12C189.333 23.7813 189.504 24.592 189.504 25.552C189.504 27.4827 188.843 28.7947 187.52 29.488C186.869 29.8293 186.107 30 185.232 30ZM184.88 23.328H176.672V27.776H184.88C185.499 27.776 185.968 27.552 186.288 27.104C186.565 26.72 186.704 26.2027 186.704 25.552C186.704 24.9013 186.565 24.384 186.288 24C185.968 23.552 185.499 23.328 184.88 23.328Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M194.219 26.832C194.219 27.4613 194.528 27.776 195.147 27.776H203.243V21.104H205.915V30H194.715C193.627 30 192.827 29.7173 192.315 29.152C191.803 28.5867 191.547 27.9627 191.547 27.28V21.104H194.219V26.832Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M218.756 24.24C218.756 23.9413 218.66 23.7067 218.468 23.536C218.329 23.408 218.116 23.344 217.828 23.344L211.188 23.328V30H208.516V21.104L218.276 21.072C219.321 21.072 220.121 21.3653 220.676 21.952C221.177 22.4853 221.428 23.0987 221.428 23.792V24.72H218.756V24.24Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.311 21.12V30.256C240.311 31.3013 240.007 32.1173 239.399 32.704C238.791 33.2907 238.012 33.584 237.063 33.584L224.695 33.552V31.472L236.583 31.488C236.999 31.488 237.287 31.3653 237.447 31.12C237.575 30.928 237.639 30.6133 237.639 30.176V30H227.991C226.604 30 225.543 29.6107 224.807 28.832C224.081 28.0427 223.719 26.9493 223.719 25.552C223.719 24.1547 224.081 23.0667 224.807 22.288C225.543 21.4987 226.604 21.104 227.991 21.104L240.311 21.12ZM228.343 23.328C227.724 23.328 227.255 23.552 226.935 24C226.657 24.384 226.519 24.9013 226.519 25.552C226.519 26.2027 226.657 26.72 226.935 27.104C227.244 27.552 227.713 27.776 228.343 27.776L237.639 27.744V23.344L228.343 23.328Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.608 27.904H256.904V30H247.256C245.87 30 244.808 29.6107 244.072 28.832C243.347 28.0427 242.984 26.9493 242.984 25.552C242.984 24.1547 243.347 23.0667 244.072 22.288C244.808 21.4987 245.87 21.104 247.256 21.104H256.904V23.2H247.608C247.118 23.2 246.712 23.3387 246.392 23.616C246.243 23.744 246.051 24.0427 245.816 24.512L245.8 24.544H256.904V26.544H245.8L245.816 26.592C246.03 27.0507 246.222 27.3493 246.392 27.488C246.712 27.7653 247.118 27.904 247.608 27.904Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M269.584 24.24C269.584 23.9413 269.488 23.7067 269.296 23.536C269.157 23.408 268.944 23.344 268.656 23.344L262.016 23.328V30H259.344V21.104L269.104 21.072C270.149 21.072 270.949 21.3653 271.504 21.952C272.005 22.4853 272.256 23.0987 272.256 23.792V24.72H269.584V24.24Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M277.347 26.544C276.515 26.544 275.838 26.304 275.315 25.824C274.803 25.3333 274.547 24.672 274.547 23.84C274.547 22.7413 274.979 21.9467 275.843 21.456C276.259 21.2213 276.76 21.104 277.347 21.104H288.675V23.2H277.875C277.288 23.2 276.995 23.424 276.995 23.872C276.995 24.32 277.288 24.544 277.875 24.544L286.355 24.56C287.187 24.56 287.859 24.8053 288.371 25.296C288.894 25.7867 289.155 26.448 289.155 27.28C289.155 28.4 288.723 29.1947 287.859 29.664C287.454 29.888 286.952 30 286.355 30H274.547V27.904L285.827 27.92C286.414 27.92 286.707 27.6907 286.707 27.232C286.707 26.784 286.414 26.56 285.827 26.56L277.347 26.544Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_31580_478",
    x: 122.012,
    y: 0.5,
    width: 43.3186,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_31580_478",
    x: 122.012,
    y: 0.5,
    width: 43.3186,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_31580_478",
    x: 119.581,
    y: 20,
    width: 48.792,
    height: 17.0129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_31580_478",
    x: 119.581,
    y: 20,
    width: 48.792,
    height: 17.0129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_31580_478",
    x: 119.5,
    y: 14.5,
    width: 49,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_31580_478",
    x: 119.5,
    y: 14.5,
    width: 49,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_31580_478",
    x: 129.885,
    y: 2.81274,
    width: 28.795,
    height: 44.1873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_31580_478",
    x: 129.885,
    y: 2.81274,
    width: 28.795,
    height: 44.1873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31580_478"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.4a0b717aa7b6b0e94485de77994e885e.svg";
export { ForwardRef as ReactComponent };